import { Box } from "@mui/material";

const buildGemGradient = (): string => {
  return `linear-gradient(90deg,
    #87CEEB 0%,
    #5DADE2 25%,
    #4A9EDD 50%,
    #3A8DD4 75%,
    #4A90E2 100%)`;
};

interface OnboardingProgressBarProps {
  height?: string;
}

export const OnboardingProgressBar = ({
  height = "12px",
}: OnboardingProgressBarProps) => {
  return (
    <Box
      sx={{
        height: height,
        borderRadius: 2,
        background: buildGemGradient(),
      }}
    />
  );
};
